import { format } from 'date-fns';

export const getInitialReportName = (name?: string): string => {
  const currentTimestamp = format(new Date(), "MM/dd/yyyy'T'HH:mm:ss");
  return `${name || 'Report'} - ${currentTimestamp}`;
};
